export enum TabListTypes {
  ADMIN = "ADMIN",
  REQUEST_DETAILS = "REQUEST_DETAILS",
  REVIEWER_REQUEST_DETAILS = "REVIEWER_REQUEST_DETAILS",
}
